import { Accordion, AccordionItem } from "@szhsin/react-accordion";

const FAQAccordion = ({ faqData }) => {
  const heading = faqData?.heading;
  const subheading = faqData?.subheading;
  const items = faqData?.items || [];
  let listToMap =
    Array.isArray(faqData) && faqData.length > 0 ? faqData : items;

  return (
    <div className="faq-section" id="faq">
      <div className="col-12 col-md-10 mx-auto text-center">
        {heading && <h2 className="fw-bold mb-3 title">{heading}</h2>}
        {subheading && <p className="text-muted">{subheading}</p>}
      </div>

      <Accordion transition transitionTimeout={250}>
        {listToMap?.map((item, index) =>
          item?.question ? (
            <AccordionItem key={index} header={item.question}>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </AccordionItem>
          ) : null
        )}
      </Accordion>
    </div>
  );
};

export default FAQAccordion;
